import {ReactComponent as Warning} from '../../../assets/header/warning.svg';
import {ReactComponent as Calculator} from '../../../assets/header/calculator.svg';
import {ReactComponent as Globe} from '../../../assets/header/globe.svg';
import {ReactComponent as FooterGlobe} from '../../../assets/icons/footerGlobe.svg';
import {ReactComponent as Gear} from '../../../assets/header/user/gear.svg';
import {ReactComponent as MyAddresses} from '../../../assets/header/user/my-addresses.svg';
import {ReactComponent as CreditCard} from '../../../assets/header/user/credit-card.svg';
import {ReactComponent as Home} from '../../../assets/header/user/home.svg';
import {ReactComponent as Office} from '../../../assets/header/user/office.svg';
import {ReactComponent as LogOut} from '../../../assets/header/user/log-out.svg';
import {ReactComponent as Users} from '../../../assets/header/user/users.svg';
import {ReactComponent as Copy} from '../../../assets/header/copy.svg';
import {ReactComponent as Burger} from '../../../assets/header/burger.svg';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {ReactComponent as ThreeDot} from '../../../assets/icons/threeDot.svg';
import {ReactComponent as Reset} from '../../../assets/icons/reset.svg';
import {ReactComponent as Notifications} from '../../../assets/icons/notifications.svg';
import {ReactComponent as Wrench} from '../../../assets/header/user/wrench.svg';
import {ReactComponent as Passport} from '../../../assets/icons/passport.svg';
import {ReactComponent as Bell} from '../../../assets/icons/bell.svg';
import {ReactComponent as Eye} from '../../../assets/icons/eye.svg';
import {ReactComponent as EyeHidden} from '../../../assets/icons/eye-hidden.svg';
import {ReactComponent as User} from '../../../assets/icons/user.svg';
import {ReactComponent as Plus} from '../../../assets/icons/plus.svg';
import {ReactComponent as Close} from '../../../assets/icons/close.svg';
import {ReactComponent as Search} from '../../../assets/icons/search.svg';
import {ReactComponent as StatisticsBox} from '../../../assets/icons/statistics-box.svg';
import {ReactComponent as TrendingUp} from '../../../assets/icons/trending-up.svg'
import {ReactComponent as Am} from '../../../assets/icons/flags/am.svg'
import {ReactComponent as At} from '../../../assets/icons/flags/at.svg'
import {ReactComponent as Be} from '../../../assets/icons/flags/be.svg'
import {ReactComponent as Nl} from '../../../assets/icons/flags/nl.svg'
import {ReactComponent as Bg} from '../../../assets/icons/flags/bg.svg'
import {ReactComponent as Cz} from '../../../assets/icons/flags/cz.svg'
import {ReactComponent as De} from '../../../assets/icons/flags/de.svg'
import {ReactComponent as Es} from '../../../assets/icons/flags/es.svg'
import {ReactComponent as Cn} from '../../../assets/icons/flags/cn.svg'
import {ReactComponent as Pl} from '../../../assets/icons/flags/pl.svg'
import {ReactComponent as Ru} from '../../../assets/icons/flags/ru.svg'
import {ReactComponent as En} from '../../../assets/icons/flags/en.svg'
import {ReactComponent as Fr} from '../../../assets/icons/flags/fr.svg'
import {ReactComponent as It} from '../../../assets/icons/flags/it.svg'
import {ReactComponent as ByAir} from '../../../assets/icons/shipping/by-air.svg'
import {ReactComponent as ByLand} from '../../../assets/icons/shipping/by-land.svg'
import {ReactComponent as Email} from '../../../assets/icons/login-page/email.svg'
import {ReactComponent as Key} from '../../../assets/icons/login-page/key.svg'
import {ReactComponent as Arrow} from '../../../assets/icons/arrow.svg'     
import {ReactComponent as ArrowWhite} from '../../../assets/icons/arrow-white.svg'
import {ReactComponent as Back} from '../../../assets/icons/back.svg'
import {ReactComponent as Location} from '../../../assets/icons/login-page/location.svg'
import {ReactComponent as Phone} from '../../../assets/icons/login-page/phone.svg'
import {ReactComponent as LoginUser} from '../../../assets/icons/login-page/user.svg'
import {ReactComponent as Filter} from '../../../assets/icons/orders/filter/filter.svg'
import {ReactComponent as FilterActive} from '../../../assets/icons/orders/filter/filter-active.svg'
import {ReactComponent as Camera} from '../../../assets/icons/user-icons/camera.svg'
import {ReactComponent as PersonalAccount} from '../../../assets/icons/user-icons/personal-account.svg'
import {ReactComponent as CompanyAccount} from '../../../assets/icons/user-icons/company-account.svg'
import {ReactComponent as CheckboxChecked} from '../../../assets/icons/checkbox/checked.svg'
import {ReactComponent as CheckboxIndeterminate} from '../../../assets/icons/checkbox/indeterminate.svg'
import {ReactComponent as CheckboxUnchecked} from '../../../assets/icons/checkbox/unchecked.svg'
import {ReactComponent as RadioChecked} from '../../../assets/icons/radio/checked.svg'
import {ReactComponent as RadioUnchecked} from '../../../assets/icons/radio/unchecked.svg'
import {ReactComponent as RecipientUser} from '../../../assets/icons/user-icons/recipient-card/user.svg'
import {ReactComponent as RecipientDocument} from '../../../assets/icons/user-icons/recipient-card/document.svg'
import {ReactComponent as RecipientCalendar} from '../../../assets/icons/user-icons/recipient-card/calendar.svg'
import {ReactComponent as RecipientPhone} from '../../../assets/icons/user-icons/recipient-card/phone.svg'
import {ReactComponent as RecipientHouse} from '../../../assets/icons/user-icons/recipient-card/house.svg'
import {ReactComponent as RecipientTaxDocument} from '../../../assets/icons/user-icons/recipient-card/tax-document.svg'
import {ReactComponent as RecipientEdit} from '../../../assets/icons/user-icons/recipient-card/recipent-edit.svg'
import {ReactComponent as RecipientImage} from '../../../assets/icons/user-icons/recipient-card/image.svg'
import {ReactComponent as RecipientMain} from '../../../assets/icons/user-icons/recipient-card/main.svg'
import {ReactComponent as List} from '../../../assets/icons/orders/switch/list.svg'
import {ReactComponent as Card} from '../../../assets/icons/orders/switch/card.svg'
import {ReactComponent as HasPrintedLabel} from '../../../assets/icons/orders/has-printed-label.svg'
import {ReactComponent as MarkAsSent} from '../../../assets/icons/orders/actions/mark-as-sent.svg'
import {ReactComponent as AddToGroup} from '../../../assets/icons/orders/actions/add-to-group.svg'
import {ReactComponent as MarkAsSentGrey} from '../../../assets/icons/orders/actions/mark-as-sent-grey.svg'
import {ReactComponent as AddToGroupGrey} from '../../../assets/icons/orders/actions/add-to-group-grey.svg'
import {ReactComponent as LocateGrey} from '../../../assets/icons/orders/actions/locate-grey.svg'
import {ReactComponent as ChangeStatusesGrey} from '../../../assets/icons/orders/actions/change-statuses-grey.svg'
import {ReactComponent as PrintLabel} from '../../../assets/icons/orders/actions/print-label.svg'
import {ReactComponent as History} from '../../../assets/icons/orders/actions/history.svg'
import {ReactComponent as PaymentSuccessful} from '../../../assets/icons/orders/actions/paymentSuccessful.svg'
import {ReactComponent as NoOrders} from '../../../assets/icons/orders/no-orders.svg'
import {ReactComponent as RemoveProduct} from '../../../assets/icons/orders/remove-product.svg'
import {ReactComponent as MoveProduct} from '../../../assets/icons/orders/move-product.svg'
import {ReactComponent as Success} from '../../../assets/icons/orders/success.svg'
import {ReactComponent as HomeDeliveryGreenBox} from '../../../assets/icons/orders/delivery/green-box.svg'
import {ReactComponent as HomeDeliveryBlueBox} from '../../../assets/icons/orders/delivery/blue-box.svg'
import {ReactComponent as HomeDelivery} from '../../../assets/icons/orders/delivery/home-delivery.svg'
import {ReactComponent as WarehouseDelivery} from '../../../assets/icons/orders/delivery/warehouse-delivery.svg'
import {ReactComponent as Upload} from '../../../assets/icons/attachment/upload.svg'
import {ReactComponent as Download} from '../../../assets/icons/attachment/download.svg'
import {ReactComponent as Image} from '../../../assets/icons/attachment/image.svg'
import {ReactComponent as Pdf} from '../../../assets/icons/attachment/pdf.svg'
import {ReactComponent as Doc} from '../../../assets/icons/attachment/doc.svg'
import {ReactComponent as NoPaymentMethod} from '../../../assets/icons/user-icons/wallet/no-payment-method.svg'
import {ReactComponent as ProductsTableRemove} from '../../../assets/icons/orders/products-table/products-table-remove.svg'
import {ReactComponent as ProductsTableTransfer} from '../../../assets/icons/orders/products-table/products-table-transfer.svg'
import {ReactComponent as ProductsTableNew} from '../../../assets/icons/orders/products-table/products-table-new.svg'
import {ReactComponent as ScanIcon} from '../../../assets/icons/orders/filter/scan.svg'
import {ReactComponent as ScanIconGreen} from '../../../assets/icons/orders/filter/scan-green.svg'
import {ReactComponent as MarkAsReadyForShipment} from '../../../assets/icons/orders/actions/mark-as-ready-for-shipment.svg'
import {ReactComponent as MarkAsReadyForShipmentGrey} from '../../../assets/icons/orders/actions/mark-as-ready-for-shipment-grey.svg'
import {ReactComponent as Locate} from '../../../assets/icons/orders/actions/locate.svg'
import {ReactComponent as Check} from '../../../assets/icons/orders/additional-services/check.svg'
import {ReactComponent as Divide} from '../../../assets/icons/orders/additional-services/divide.svg'
import {ReactComponent as OnHold} from '../../../assets/icons/orders/additional-services/on_hold.svg'
import {ReactComponent as Repack} from '../../../assets/icons/orders/additional-services/repack.svg'
import {ReactComponent as TakeAPhoto} from '../../../assets/icons/orders/additional-services/take_a_photo.svg'
import {ReactComponent as TakeAPhotoFromInside} from '../../../assets/icons/orders/additional-services/take_a_photo_from_inside.svg'
import {ReactComponent as ChangeStatuses} from '../../../assets/icons/orders/actions/change-statuses.svg'
import {
    AdditionalServiceIcons,
    AttachmentIcons,
    AuthIcons,
    OrderIcons,
    RecipientIcons,
    UserIcons,
    ViewIcons
} from './variants';

export const BarekamIcon = (props: BarekamIconProps) => {
    const svgProps = {...props.size, rotate: props.rotation ? `${props.rotation}deg` : 'unset', filter: props.variant === IconVariants.flag ? 'unset !important': 'unset', fill: props?.fill ?? 'none'}
    
    return <Icon {...props} svgProps={svgProps}/>
};

const Icon = ({variant, isChecked, indeterminate, country, shippingMethod, isLoginPage, isListAction, svgProps, onClick}: BarekamIconProps) => {
    switch (variant) {
        case IconVariants.trendingUp:
            return <TrendingUp onClick={onClick} {...svgProps}/>
        case IconVariants.bell:
            return <Bell onClick={onClick} {...svgProps}/>
        case IconVariants.eye:
            return <Eye onClick={onClick} {...svgProps}/>
        case IconVariants.eyeHidden:
            return <EyeHidden onClick={onClick} {...svgProps}/>
        case IconVariants.calculator:
            return <Calculator onClick={onClick} {...svgProps}/>
        case IconVariants.passport:
            return <Passport onClick={onClick} {...svgProps}/>
        case IconVariants.globe:
            return <Globe onClick={onClick} {...svgProps}/>
        case IconVariants.footerGlobe:
            return <FooterGlobe onClick={onClick} {...svgProps}/>
        case IconVariants.gear:
            return <Gear onClick={onClick} {...svgProps}/>
        case IconVariants.myAddresses:
            return <MyAddresses onClick={onClick} {...svgProps}/>
        case IconVariants.creditCard:
            return <CreditCard onClick={onClick} {...svgProps}/>
        case IconVariants.home:
            return <Home onClick={onClick} {...svgProps}/>
        case IconVariants.office:
            return <Office onClick={onClick} {...svgProps}/>
        case IconVariants.logOut:
            return <LogOut onClick={onClick} {...svgProps}/>
        case IconVariants.users:
            return <Users onClick={onClick} {...svgProps}/>
        case IconVariants.wrench:
            return <Wrench onClick={onClick} {...svgProps}/>
        case IconVariants.plus:
            return <Plus onClick={onClick} {...svgProps}/>
        case IconVariants.close:
            return <Close onClick={onClick} {...svgProps}/>
        case IconVariants.search:
            return <Search onClick={onClick} {...svgProps}/>
        case IconVariants.user:
            return isLoginPage
                ? <LoginUser onClick={onClick} {...svgProps}/>
                : <User onClick={onClick} {...svgProps}/>
        case IconVariants.warning:
            return <Warning onClick={onClick} {...svgProps}/>
        case IconVariants.statisticsBox:
            return <StatisticsBox onClick={onClick} {...svgProps}/>
        case IconVariants.email:
            return <Email onClick={onClick} {...svgProps}/>
        case IconVariants.location:
            return <Location onClick={onClick} {...svgProps}/>
        case IconVariants.phone:
            return <Phone onClick={onClick} {...svgProps}/>
        case IconVariants.key:
            return <Key onClick={onClick} {...svgProps}/>
        case IconVariants.arrow:
            return <Arrow onClick={onClick} {...svgProps}/>
        case IconVariants.arrowWhite:
            return <ArrowWhite onClick={onClick} {...svgProps}/>
        case IconVariants.back:
            return <Back onClick={onClick} {...svgProps}/>
        case IconVariants.camera:
            return <Camera onClick={onClick} {...svgProps}/>
        case IconVariants.filter:
            return <Filter onClick={onClick} {...svgProps}/>
        case IconVariants.filterActive:
            return <FilterActive onClick={onClick} {...svgProps}/>
        case IconVariants.checkbox:
            return indeterminate
                ? <CheckboxIndeterminate onClick={onClick} {...svgProps}/>
                : isChecked
                    ? <CheckboxChecked onClick={onClick} {...svgProps}/>
                    : <CheckboxUnchecked onClick={onClick} {...svgProps}/>
        case IconVariants.radio:
            return isChecked
                ? <RadioChecked onClick={onClick} {...svgProps}/>
                : <RadioUnchecked onClick={onClick} {...svgProps}/>
        case IconVariants.copy:
            return <Copy onClick={onClick} {...svgProps}/>
        case IconVariants.burger:
            return <Burger onClick={onClick} {...svgProps}/>
        case IconVariants.edit:
            return <Edit onClick={onClick} {...svgProps}/>
        case IconVariants.threeDot:
            return <ThreeDot onClick={onClick} {...svgProps}/>
        case IconVariants.reset:
            return <Reset onClick={onClick} {...svgProps}/>
        case IconVariants.notifications:
            return <Notifications onClick={onClick} {...svgProps}/>
        case IconVariants.flag:
            return getFlag(country, svgProps, onClick);
        case IconVariants.shipping:
            switch (shippingMethod) {
                case 'by_air':
                    return <ByAir onClick={onClick} {...svgProps}/>;
                default:
                case 'by_land':
                    return <ByLand onClick={onClick} {...svgProps}/>;
            }
        case AuthIcons.personalAccount:
            return <PersonalAccount onClick={onClick} {...svgProps}/>
        case AuthIcons.companyAccount:
            return <CompanyAccount onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientUser:
            return <RecipientUser onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientDocument:
            return <RecipientDocument onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientCalendar:
            return <RecipientCalendar onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientPhone:
            return <RecipientPhone onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientHouse:
            return <RecipientHouse onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientTaxDocument:
            return <RecipientTaxDocument onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientEdit:
            return <RecipientEdit onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientImage:
            return <RecipientImage onClick={onClick} {...svgProps}/>
        case RecipientIcons.recipientMain:
            return <RecipientMain onClick={onClick} {...svgProps}/>
        case ViewIcons.list:
            return <List onClick={onClick} {...svgProps}/>
        case ViewIcons.card:
            return <Card onClick={onClick} {...svgProps}/>
        case OrderIcons.noOrders:
            return <NoOrders onClick={onClick} {...svgProps}/>
        case OrderIcons.removeProduct:
            return <RemoveProduct onClick={onClick} {...svgProps}/>
        case OrderIcons.moveProduct:
            return <MoveProduct onClick={onClick} {...svgProps}/>
        case OrderIcons.success:
            return <Success onClick={onClick} {...svgProps}/>
        case OrderIcons.homeDeliveryBlueBox:
            return <HomeDeliveryBlueBox onClick={onClick} {...svgProps}/>
        case OrderIcons.homeDeliveryGreenBox:
            return <HomeDeliveryGreenBox onClick={onClick} {...svgProps}/>
        case OrderIcons.productsTableRemove:
            return <ProductsTableRemove onClick={onClick} {...svgProps}/>
        case OrderIcons.productsTableTransfer:
            return <ProductsTableTransfer onClick={onClick} {...svgProps}/>
        case OrderIcons.productsTableNew:
            return <ProductsTableNew onClick={onClick} {...svgProps}/>
        case OrderIcons.homeDelivery:
            return <HomeDelivery onClick={onClick} {...svgProps}/>
        case OrderIcons.warehouseDelivery:
            return <WarehouseDelivery onClick={onClick} {...svgProps}/>
        case OrderIcons.scanOrder:
            return <ScanIcon onClick={onClick} {...svgProps}/>
        case OrderIcons.scanOrderGreen:
            return <ScanIconGreen onClick={onClick} {...svgProps}/>
        case OrderIcons.locate:
            return isListAction
                ? <LocateGrey onClick={onClick} {...svgProps}/>
                : <Locate onClick={onClick} {...svgProps}/>
        case OrderIcons.changeStatuses:
            return isListAction
                ? <ChangeStatusesGrey onClick={onClick} {...svgProps}/>
                : <ChangeStatuses onClick={onClick} {...svgProps}/>
        case OrderIcons.markAsReadyForShipment:
            return isListAction
                ? <MarkAsReadyForShipmentGrey onClick={onClick} {...svgProps}/>
                : <MarkAsReadyForShipment onClick={onClick} {...svgProps}/>
        case OrderIcons.hasPrintedLabel:
            return <HasPrintedLabel onClick={onClick} {...svgProps}/>
        case OrderIcons.markAsSent:
            return isListAction
                ? <MarkAsSentGrey onClick={onClick} {...svgProps}/>
                : <MarkAsSent onClick={onClick} {...svgProps}/>
        case OrderIcons.addToGroup:
            return isListAction
                ? <AddToGroupGrey onClick={onClick} {...svgProps}/>
                : <AddToGroup onClick={onClick} {...svgProps}/>
        case OrderIcons.printLabel:
            return <PrintLabel onClick={onClick} {...svgProps}/>
        case OrderIcons.history:
            return <History onClick={onClick} {...svgProps}/>
        case OrderIcons.paymentSuccessful:
            return <PaymentSuccessful onClick={onClick} {...svgProps}/>
        case AttachmentIcons.upload:
            return <Upload onClick={onClick} {...svgProps}/>
        case AttachmentIcons.download:
            return <Download onClick={onClick} {...svgProps}/>
        case AttachmentIcons.image:
            return <Image onClick={onClick} {...svgProps}/>
        case AttachmentIcons.pdf:
            return <Pdf onClick={onClick} {...svgProps}/>
        case AttachmentIcons.doc:
            return <Doc onClick={onClick} {...svgProps}/>
        case UserIcons.noPaymentMethod:
            return <NoPaymentMethod onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.takeAPhoto:
            return <TakeAPhoto onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.onHold:
            return <OnHold onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.takeAPhotoFromInside:
            return <TakeAPhotoFromInside onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.check:
            return <Check onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.divide:
            return <Divide onClick={onClick} {...svgProps}/>
        case AdditionalServiceIcons.repack:
            return <Repack onClick={onClick} {...svgProps}/>
        default:
            return <></>
    }
}
function getFlag(country: string | undefined, svgProps: any, onClick?: () => void | undefined, ) {
    switch (country) {
        case 'hy':
            return <Am onClick={onClick} {...svgProps}/>
        case 'at':
            return <At onClick={onClick} {...svgProps}/>
        case 'cz':
            return <Cz onClick={onClick} {...svgProps}/>
        case 'de':
            return <De onClick={onClick} {...svgProps}/>
        case 'es':
            return <Es onClick={onClick} {...svgProps}/>
        case 'pl':
            return <Pl onClick={onClick} {...svgProps}/>
        case 'be':
            return <Be onClick={onClick} {...svgProps}/>
        case 'nl':
            return <Nl onClick={onClick} {...svgProps}/>
        case 'bg':
            return <Bg onClick={onClick} {...svgProps}/>
        case 'cn':
            return <Cn onClick={onClick} {...svgProps}/>
        case 'en':
            return <En onClick={onClick} {...svgProps}/>
        case 'ru':
            return <Ru onClick={onClick} {...svgProps}/>
        case 'fr':
            return <Fr onClick={onClick} {...svgProps}/>
        case 'it':
            return <It onClick={onClick} {...svgProps}/>
        default:
            return <></>
    }
}

export interface BarekamIconProps {
    variant: IconVariants | AuthIcons | RecipientIcons | ViewIcons | OrderIcons | AttachmentIcons | UserIcons | AdditionalServiceIcons,

    onClick?: () => void;
    noFilter?: boolean;
    isChecked?: boolean;
    indeterminate?: boolean;
    shippingMethod?: string;
    country?: string;
    isLoginPage?: boolean;
    isListAction?: boolean;
    size?: {width: string, height: string};
    rotation?: number;
    fill?: string;
    svgProps?: any;
}

export enum IconVariants { // TODO: group icons
    'trendingUp' ,
    'filter' ,
    'filterActive',
    'bell' ,
    'eye' ,
    'eyeHidden' ,
    'calculator' ,
    'passport' ,
    'globe' ,
    'footerGlobe' ,
    'copy',
    'burger',
    'edit',
    'gear' ,
    'myAddresses' ,
    'creditCard' ,
    'home' ,
    'office' ,
    'threeDot',
    'reset',
    'notifications',
    'logOut' , 'users' , 'wrench' , 'plus' , 'close' , 'search' , 'user' , 'warning' , 'statisticsBox' , 'checkbox' , 'radio' , 'flag' , 'shipping' ,'email', 'location' , 'phone' , 'key' , 'arrow' , 'back', 'camera', 'arrowWhite'
}